import { render } from "./ProductMatrix.vue?vue&type=template&id=780e0fca&scoped=true"
import script from "./ProductMatrix.vue?vue&type=script&lang=js"
export * from "./ProductMatrix.vue?vue&type=script&lang=js"

import "./ProductMatrix.vue?vue&type=style&index=0&id=780e0fca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780e0fca"]])

export default __exports__